import { IAppState } from '../app.state';
import { createSelector } from '@ngrx/store';
import { IGruposState } from '../reducers/grupos.reducers';

export const selectGruposList = createSelector(
    (state: IAppState) => state.grupos,
    (state: IGruposState) => state.grupos
);

export const selectAsistenciasList = createSelector(
    (state: IAppState) => state.grupos,
    (state: IGruposState) => state.asistencias
);

export const selectSesionesList = createSelector(
    (state: IAppState) => state.grupos,
    (state: IGruposState) => state.sesiones
);